import {
  PROFILE_CREATE_FAIL,
  PROFILE_CREATE_REQUEST,
  PROFILE_CREATE_RESET,
  PROFILE_CREATE_SUCCESS,
  PROFILE_EDIT_FAIL,
  PROFILE_EDIT_REQUEST,
  PROFILE_EDIT_RESET,
  PROFILE_EDIT_SUCCESS,
  PROFILE_UPDATE_FAIL,
  PROFILE_UPDATE_REQUEST,
  PROFILE_UPDATE_RESET,
  PROFILE_UPDATE_SUCCESS,
  PROFILE_LIST_FAIL,
  PROFILE_LIST_REQUEST,
  PROFILE_LIST_SUCCESS,
  PROFILE_LIST_RESET,
} from "../Constants/ProfileConstants";

// PROFILE CREATE
export const profileCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case PROFILE_CREATE_REQUEST:
      return { loading: true };
    case PROFILE_CREATE_SUCCESS:
      return { loading: false, success: true, result: action.payload };
    case PROFILE_CREATE_FAIL:
      return { loading: false, error: true, result: action.payload };
    case PROFILE_CREATE_RESET:
      return {};
    default:
      return state;
  }
};

// PROFILE EDIT
export const profileEditReducer = (
  state = { recordItem: undefined },
  action
) => {
  switch (action.type) {
    case PROFILE_EDIT_REQUEST:
      return { ...state, loading: true };
    case PROFILE_EDIT_SUCCESS:
      return { loading: false, recordItem: action.payload.item };
    case PROFILE_EDIT_FAIL:
      return { loading: false, error: action.payload };
    case PROFILE_EDIT_RESET:
      return {};
    default:
      return state;
  }
};

// PROFILE UPDATE
export const profileUpdateReducer = (state = { data: {} }, action) => {
  switch (action.type) {
    case PROFILE_UPDATE_REQUEST:
      return { loading: true };
    case PROFILE_UPDATE_SUCCESS:
      return {
        loading: false,
        success: true,
        recordItem: action.payload.item,
      };
    case PROFILE_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case PROFILE_UPDATE_RESET:
      return { data: {} };
    default:
      return state;
  }
};

// PROFILE LIST
// export const profileListReducer = (state = { data: [] }, action) => {
//   switch (action.type) {
//     case PROFILE_LIST_REQUEST:
//       return { loading: true, recordItems: [], nextStartKey: null };
//     case PROFILE_LIST_SUCCESS:
//       return {
//         loading: false,
//         success: true,
//         pages: action.payload.pages,
//         nextStartKey: action.payload.nextStartKey,
//         recordItems: action.payload.items,
//       };
//     case PROFILE_LIST_FAIL:
//       return { loading: false, error: action.payload };
//     default:
//       return state;
//   }
// };
// export const profileListReducer = (state = { profiles: [] }, action) => {
//   switch (action.type) {
//     case PROFILE_LIST_REQUEST:
//       return { loading: true, profiles: [] };
//     case PROFILE_LIST_SUCCESS:
//       return {
//         loading: false,
//         success: true,
//         hasMore: action.payload.hasMore,
//         nextStartKey: action.payload.nextStartKey,
//         profiles: action.payload.items,
//       };
//     case PROFILE_LIST_FAIL:
//       return { loading: false, error: action.payload };
//     case PROFILE_LIST_RESET:
//       return { loading: false, profiles: null };
//     default:
//       return state;
//   }
// };

const initialState = {
  loading: false,
  error: null,
  profiles: [],
  nextStartKey: null,
  hasMore: false,
  filters: {},
};

export const profileListReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROFILE_LIST_REQUEST:
      return { ...state, loading: true };

    case PROFILE_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        profiles: action.append
          ? [...state.profiles, ...action.payload.items]
          : action.payload.items,
        nextStartKey: action.payload.nextStartKey,
        hasMore: action.payload.hasMore,
        filters: action.filters,
      };

    case PROFILE_LIST_FAIL:
      return { ...state, loading: false, error: action.payload };

    case PROFILE_LIST_RESET:
      return initialState;

    default:
      return state;
  }
};
